import { useEffect, useState, lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import "./themes.css";
import "./gotham.css";
import "./crayons.css";
import "./ukiyo.css";
import "./gazette.css";

const About = lazy(() => import("./components/About"));
const Posts = lazy(() => import("./components/Posts"));
const Footer = lazy(() => import("./components/Footer"));
const Feed = lazy(() => import("./components/Feed"));
const Reading = lazy(() => import("./components/Reading"));
const Music = lazy(() => import("./components/Music"));
const CV = lazy(() => import("./components/CV"));
const GitHub = lazy(() => import("./components/GitHub"));
const NotFound = lazy(() => import("./components/NotFound"));

function App() {
  const [headerContent, setHeaderContent] = useState({
    name: "Divyansh Jain",
    title: "Frontend Developer",
    links: [],
  });

  useEffect(() => {
    const fetchHeaderContent = async () => {
      try {
        const response = await fetch(
          "https://api.github.com/repos/BlackDranzer777/portfolio3.0/contents/name.txt",
          {
            headers: {
              Authorization: `token ${process.env.REACT_APP_GITHUB_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        const decodedContent = atob(data.content);
        const lines = decodedContent.split("\n").filter(Boolean);
        const name = lines[0];
        const title = lines[1];
        const links = lines.slice(2).map((line) => {
          const [name, url] = line.split("::");
          return { name, url };
        });
        setHeaderContent({ name, title, links });
      } catch (error) {
        console.error("Error fetching header content:", error);
      }
    };

    fetchHeaderContent();
  }, []);

  return (
    <Router>
      <div className="app">
        <Header headerContent={headerContent} />
        <main>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/about" element={<About />} />
              <Route path="/" element={<Posts />} />
              <Route path="/feed/:id" element={<Feed />} />
              <Route path="/reading" element={<Reading />} />
              <Route path="/music" element={<Music />} />
              <Route path="/cv" element={<CV />} />
              <Route path="/github" element={<GitHub />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer headerContent={headerContent} />
      </div>
    </Router>
  );
}

export default App;
